<template>
  <b-card-text class="partner">
    <p>
      {{ $t('referral.tabPartnerProgram.firstContentTab') }}
    </p>

    <ul class="list-content">
      <li>{{ $t('referral.tabPartnerProgram.contentProfitable') }}</li>
      <li>{{ $t('referral.tabPartnerProgram.contentFlexible') }}</li>
      <li>{{ $t('referral.tabPartnerProgram.contentScalable') }}</li>
      <li>{{ $t('referral.tabPartnerProgram.contentSimple') }}</li>
    </ul>

    <h3>
      {{ $t('referral.tabPartnerProgram.titlePleaseLeaveInfo') }}
    </h3>

    <div class="partner-content d-flex justify-content-space-between flex-wrap">

      <div class="form-partner mr-0 mr-md-4">
        <validation-observer ref="partnerValidation">
          <b-form class="auth-partner-form mt-2">
            <!-- username -->
            <b-form-group class="my-2">
              <div class="d-flex justify-content-between">
                <label for="fullname">
                  {{ $t('common.labelName') }}
                </label>
              </div>
              <validation-provider
                #default="{ errors }"
                id="fullname"
                :name="$t('common.labelFullName')"
                rules="required"
              >
                <b-form-input
                  v-model="fullname"
                  id="partner-fullname"
                  name="partner-fullname"
                  class="input-height"
                  :state="errors.length > 0 ? false : null"
                  :placeholder="$t('common.placeholderName')"
                />
                <small class="text-danger">{{ errors[0] }}</small>
              </validation-provider>
            </b-form-group>

            <!-- email -->
            <b-form-group
              label-for="partner-email"
            >
              <div class="d-flex justify-content-between">
                <label for="email">
                  {{ $t('common.labelEmail') }}
                </label>
              </div>
              <validation-provider
                #default="{ errors }"
                id="email"
                name="Email"
                rules="required|email"
              >
                <b-form-input
                  v-model.trim="userEmail"
                  id="partner-email"
                  name="partner-email"
                  class="input-height"
                  :placeholder="$t('common.placeholderEmail')"
                  :state="errors.length > 0 ? false:null"
                />
                <small class="text-danger">{{ errors[0] }}</small>
              </validation-provider>
            </b-form-group>

            <!-- reference -->
            <b-form-group class="my-2">
              <div class="d-flex justify-content-between">
                <label for="whatsapp">
                  Whatsapp
                </label>
              </div>
              <validation-provider
                #default="{ errors }"
                id="whatsapp"
                name="Whatsapp"
                rules="required"
              >
                <b-form-input
                  v-model="whatsapp"
                  id="partner-whatsapp"
                  name="partner-whatsapp"
                  class="input-height"
                  :state="errors.length > 0 ? false : null"
                  :placeholder="$t('common.placeholderWhatsapp')"
                />
                <small class="text-danger">{{ errors[0] }}</small>
              </validation-provider>
            </b-form-group>

            <!-- facebook -->
            <b-form-group
              label-for="partner-facebook"
            >
              <div class="d-flex justify-content-between">
                <label for="facebook">
                  {{ $t('referral.tabPartnerProgram.labelFacebookProfileLink') }}
                </label>
              </div>
              <validation-provider
                #default="{ errors }"
                id="facebook"
                name="Facebook"
                rules="required|url"
              >
                <b-form-input
                  v-model.trim="facebook"
                  id="partner-facebook"
                  class="form-control-merge input-height"
                  name="partner-facebook"
                  :placeholder="$t('common.placeholderFacebook')"
                  :state="errors.length > 0 ? false:null"
                />
                <small class="text-danger">{{ errors[0] }}</small>
              </validation-provider>
            </b-form-group>

            <!-- message -->
            <b-form-group
              label-for="partner-message"
            >
              <div class="d-flex justify-content-between">
                <label for="partnerMessage">
                  {{ $t('referral.tabPartnerProgram.labelMessage') }}
                </label>
              </div>
              <validation-provider
                #default="{ errors }"
                id="partnerMessage"
                :name="$t('referral.tabPartnerProgram.labelMessage')"
                rules="required|messageLength"
              >
                <b-form-textarea
                  v-model.trim="partnerMessage"
                  id="partner-message"
                  class="form-control-merge input-height"
                  name="partner-message"
                  :placeholder="$t('referral.tabPartnerProgram.textWriteSomething')"
                  rows="4"
                  :state="errors.length > 0 ? false:null"
                />
                <small class="text-danger">{{ errors[0] }}</small>
              </validation-provider>
            </b-form-group>

            <btn-loading
              id="trigger-send-information"
              span-id="trigger-send-information-child"
              class="mt-3 mb-4 input-height"
              variant-convert="btn-submit"
              block
              type="submit"
              :loading="loading"
              @click.prevent="validationForm"
            >
              {{ $t('referral.tabPartnerProgram.textSendInformation') }}
            </btn-loading>
          </b-form>
        </validation-observer>
      </div>

      <div class="address-info">
        <b-img
          alt="logo"
          name="logo"
          :src="logo"
          class="mt-2"
        />

        <ul class="address-info-detail mt-2">
          <li v-if="addressPartnership || officesPartnership">
            <div class="d-flex flex-column">
              <p class="m-0 d-flex">
                <feather-icon
                  size="24"
                  icon="MapPinIcon"
                  class="ic-address"
                  style="min-width: 24px;"
                />
                <span>
                  {{ $t('referral.tabPartnerProgram.textAddress') }}:
                </span>
              </p>
              <div class="address-offices">
                <p
                  v-if="addressPartnership"
                  class="m-0"
                >
                  <span class="underline decoration-solid">HQ:</span> <span>{{ addressPartnership }}</span>
                </p>
                <div v-if="officesPartnership">
                  <p class="underline decoration-solid m-0">
                    {{ $t('referral.tabPartnerProgram.textOffices') }}:
                  </p>
                  <div>
                    <p class="m-0">
                      {{ officesPartnership }}
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </li>
          <li v-if="phoneNumberPartnership">
            <feather-icon
              size="24"
              icon="PhoneCallIcon"
              style="min-width: 24px;"
            />
            <p>{{ $t('referral.tabPartnerProgram.textHotline') }}: <a :href="`tel:${phoneNumberPartnership}`">{{ phoneNumberPartnership }}</a></p>
          </li>
          <li v-if="emailPartnership">
            <feather-icon
              size="24"
              icon="MailIcon"
              style="min-width: 24px;"
            />
            <p>Email: <a :href="`mailto:${emailPartnership}`">{{ emailPartnership }}</a></p>
          </li>
          <li v-if="telegramPartnership">
            <feather-icon
              size="24"
              icon="SmartphoneIcon"
              style="min-width: 24px;"
            />
            <p>Telegram: <a :href="telegramPartnership">{{ telegramPartnership }}</a></p>
          </li>
          <li v-if="instagramPartnership">
            <feather-icon
              size="24"
              icon="InstagramIcon"
              style="min-width: 24px;"
            />
            <p>Telegram: <a :href="instagramPartnership">{{ instagramPartnership }}</a></p>
          </li>
          <li v-if="whatsAppPartnership">
            <feather-icon
              size="24"
              icon="HeadphonesIcon"
              style="min-width: 24px;"
            />
            <p>Whatsapp: <a :href="whatsAppPartnership">{{ whatsAppPartnership }}</a></p>
          </li>
          <li v-if="facebookPartnership">
            <feather-icon
              size="24"
              icon="FacebookIcon"
              style="min-width: 24px;"
            />
            <p>Link fanpage: <a :href="facebookPartnership">{{ facebookPartnership }}</a></p>
          </li>
        </ul>
      </div>
    </div>

  </b-card-text>
</template>

<script>
import axios from '@axios'
/* eslint-disable global-require */
import { ValidationProvider, ValidationObserver } from 'vee-validate'
import {
  BCardText, BImg,
  BForm, BFormGroup, BFormInput, BFormTextarea,
} from 'bootstrap-vue'
import { toastification } from '@core/mixins/toast'
import { $themeConfig } from '@themeConfig'
import BtnLoading from '@/layouts/components/BtnLoading.vue'
import {
  required,
  email,
  url,
  messageLength,
} from '@validations'
import envMixin from '@/mixins/envMixin'

export default {
  components: {
    BCardText,
    BForm,
    BFormGroup,
    BFormInput,
    BImg,
    BtnLoading,
    // validations
    ValidationProvider,
    ValidationObserver,
    BFormTextarea,
  },
  mixins: [toastification, envMixin],
  data() {
    return {
      loading: false,
      fullname: '',
      userEmail: '',
      whatsapp: '',
      facebook: '',
      partnerMessage: '',
      required,
      email,
      url,
      messageLength,
      imgUrl: require('@/assets/images/logo/logo-ecomdy-media.svg'),
    }
  },
  setup() {
    // App Name
    const { appName, appLogoImage } = $themeConfig.app
    return {
      appName,
      appLogoImage,
    }
  },
  computed: {
  },
  methods: {
    cleanForm() {
      this.fullname = ''
      this.userEmail = ''
      this.whatsapp = ''
      this.facebook = ''
      this.partnerMessage = ''
      this.$nextTick(() => this.$refs.partnerValidation.reset())
    },
    async validationForm() {
      const success = await this.$refs.partnerValidation.validate()
      if (success) {
        this.loading = true
        const params = {
          name: this.fullname,
          email: this.userEmail,
          whatsApp: this.whatsapp,
          fbProfileUrl: this.facebook,
          message: this.partnerMessage,
        }
        axios.post('/api/partners', params)
          .then(res => {
            // Perform Success Action
            if (res) {
              this.toastSuccess(this.$t('referral.tabPartnerProgram.toastSubmitInfoSuccess'))
            }
            this.cleanForm()
          })
          .catch(error => {
            // error.response.status Check status code
            this.toastFailure(error.toString())
          })
          .finally(() => {
            this.loading = false
          })
      }
    },
  },
}
</script>
<style scoped>
a {
  color: #6e44ff;
}

.ic-address{
  margin-right: 20px;
}

.address-offices{
  margin-left: 44px;
  margin-bottom: 1rem;
}

.list-content{
  list-style-type: disc;
  margin-left: 1rem;
}
</style>
